export type PipelineStage =
  | 'CANDIDATE'
  | 'LEAD'
  | 'LEAD_WITH_EOI'
  | 'OPPORTUNITY'
  | 'COMMITTED_INVESTOR';

export interface PipelineStageActionLabels {
  promotionLabel?: string;
  demotionLabel?: string;
}

const LABELS: Record<PipelineStage, PipelineStageActionLabels> = {
  CANDIDATE: { promotionLabel: 'Promote to Lead' },
  LEAD: { promotionLabel: 'Submit EOI', demotionLabel: 'Demote to Candidate' },
  LEAD_WITH_EOI: { promotionLabel: 'Promote to Opportunity', demotionLabel: 'Withdraw EOI' },
  OPPORTUNITY: { promotionLabel: 'Commit Investment', demotionLabel: 'Demote to Lead' },
  COMMITTED_INVESTOR: { demotionLabel: 'Demote to Opportunity' },
};

export function pipelineStageActionLabels(stage: string): PipelineStageActionLabels {
  return LABELS[stage as PipelineStage] ?? {};
}
